/**
 * The state behind a WindowPicker's custom box (TRA-1436, TRA-1461): its
 * text and whether the last apply was refused. A bad value keeps the
 * current window and lights the box; the page says why wherever it wants
 * with `WindowBoxError`, which is why this lives outside the picker.
 */

import { useState } from 'react'

import { parseWindowHours } from '@/components/models/home/scalingWindow'

export interface WindowBox {
  value: string
  invalid: boolean
  setValue: (value: string) => void
  /** Reads the box: applies a good window, lights the box on a bad one, ignores an empty one. */
  apply: () => void
  /** Clears the box, as picking a pill does. */
  reset: () => void
}

export function useWindowBox(maxHours: number, onApply: (hours: number) => void): WindowBox {
  const [value, setValue] = useState('')
  const [invalid, setInvalid] = useState(false)

  function apply(): void {
    if (value.trim() === '') {
      setInvalid(false)
      return
    }
    const hours = parseWindowHours(value, maxHours)
    setInvalid(hours === null)
    if (hours !== null) onApply(hours)
  }

  function reset(): void {
    setValue('')
    setInvalid(false)
  }

  return { value, invalid, setValue, apply, reset }
}
